import { createApi } from "@reduxjs/toolkit/query/react";
import { cacheDurationSeconds } from "common/constants";
import { ISupportForm } from "redux/utils/interfaces";
import { baseQueryWithReauth } from "./utils/constants";

import {
	UserParams,
	createUserParams
} from "./utils/interfaces";

const getUrlParams = (args) => {
	if (!args.sortBy && !args.filterBy) {
		return `limit=${args.limit}&offset=${args.offset}`;
	} else if (args.sortBy && !args.filterBy) {
		return `limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}`;
	} else if (!args.sortBy && args.filterBy) {
		return `limit=${args.limit}&offset=${args.offset}&filterBy=${args.filterBy}`;
	} else if (args.sortBy && args.filterBy) {
		return `limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}&filterBy=${args.filterBy}`;
	}
	return `limit=${args.limit}&offset=${args.offset}`;
};

const getUrlParamsForTransactions = (args) => {
	if (!args.sortBy) {
		return `userName=${args.userName}&locationId.stationId=${args.locationIdStationId}&limit=${args.limit}&offset=${args.offset}&userId=${args.userId}`;
	}
	return `userName=${args.userName}&locationId.stationId=${args.locationIdStationId}&limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}&userId=${args.userId}`;
};

export const userApi = createApi({
	reducerPath: "user",
	baseQuery: baseQueryWithReauth,
	keepUnusedDataFor: cacheDurationSeconds,
	endpoints: (builder) => ({
		getUsers: builder.query<any, UserParams>({
			query: (args) => ({
				url: `get-users?${getUrlParams(args)}`,
				// keepUnusedDataFor: 0
			}),
		}),
		createUser: builder.mutation<any, createUserParams>({
			query: (data) => {
				const { licensePlate, userName, billingPeriod, contactNumber, unitNumber, locaStationId, priorityType, chargePointId, email, expireAt } = data;
				return {
					url: "create-user",
					method: "PUT",
					body: {
						"licensePlate": licensePlate ? licensePlate : "",
						"userName": userName ? userName : "",
						"billingPeriod": billingPeriod ? billingPeriod : "",
						"contactNumber": contactNumber ? contactNumber : "",
						"expireAt": expireAt ? expireAt : "",
						"unitNumber": unitNumber ? unitNumber : "",
						"locationId.stationId": locaStationId ? locaStationId : "",
						"priorityType": priorityType ? priorityType : "",
						"chargePointId": chargePointId ? chargePointId : "",
						"email": email ? email : "",
					}
				}
			},
		}),
		getUserBilling: builder.query<any, any>({
			query: (args:any) => ({
				url: `get-user-statements?${getUrlParamsForTransactions(args)}`,
			}),
		}),
	}),
});

export const {
	useGetUsersQuery,
	useCreateUserMutation,
	useGetUserBillingQuery
} =
	userApi;

